import p1v from "./../assets/renders/project01/v.png";
import p1h from "./../assets/renders/project01/h.png";
import p2v from "./../assets/renders/project02/v.png";
import p2h from "./../assets/renders/project02/h.png";

import p1_1 from "./../assets/renders/project01/01.png";
import p1_2 from "./../assets/renders/project01/02.png";
import p1_3 from "./../assets/renders/project01/03.png";
import p1_4 from "./../assets/renders/project01/04.png";
import p1_5 from "./../assets/renders/project01/05.png";
import p1_6 from "./../assets/renders/project01/06.png";
import p1_7 from "./../assets/renders/project01/07.png";
import p1_8 from "./../assets/renders/project01/08.png";
import p1_9 from "./../assets/renders/project01/09.png";


import p2_1 from "./../assets/renders/project02/01.png";
import p2_2 from "./../assets/renders/project02/02.png";
import p2_3 from "./../assets/renders/project02/03.png";
import p2_4 from "./../assets/renders/project02/04.png";
import p2_5 from "./../assets/renders/project02/05.png";
import p2_6 from "./../assets/renders/project02/06.png";
import p2_7 from "./../assets/renders/project02/07.png";

import p3_1 from "./../assets/renders/project03/01.png";
import p3_2 from "./../assets/renders/project03/02.png";
import p3_3 from "./../assets/renders/project03/03.png";
import p3_5 from "./../assets/renders/project03/05.png";
import p3_6 from "./../assets/renders/project03/06.png";
import p3_v from "./../assets/renders/project03/v.png";

import p4_1 from "./../assets/renders/project04/01.png";
import p4_2 from "./../assets/renders/project04/02.png";
import p4_3 from "./../assets/renders/project04/03.png";
import p4_4 from "./../assets/renders/project04/04.png";
import p4_5 from "./../assets/renders/project04/05.png";
import p4_6 from "./../assets/renders/project04/06.png";


const projects = [
  {
    id: 1,
    title: 'Projeto S&J',
    horizontalImage: p1h,
    verticalImage: p1v,
    images: [p1_1, p1_2, p1_3, p1_4, p1_5, p1_6, p1_7, p1_8, p1_9, p1v, p1h]
  },
  {
    id: 2,
    title: 'Projeto S&J',
    horizontalImage: p2h,
    verticalImage: p2v,
    images: [p2_1, p2_2, p2_3, p2_4, p2_5, p2_6, p2_7, p2v, p2h]

  },
  {
    id: 3,
    title: 'Projeto J&U',
    horizontalImage: p3_1,
    verticalImage: p3_v,
    images: [p3_1, p3_2, p3_3, p3_v, p3_5, p3_6 ]
  },
  {
    id: 4,
    title: 'Projeto SP',
    horizontalImage: p4_3,
    verticalImage: p4_1,
    images: [p4_1, p4_2, p4_3,p4_4,p4_5,p4_6]
  },
]



export default projects;
  